var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.section),attrs:{"id":"signedRepo"}},[_c('Header'),_c('div',[_c('div',{staticClass:"padding-top-bottom-2rem",attrs:{"id":"signedRepo_section"}},[_c('router-view')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }